// @flow
import { all, fork } from "redux-saga/effects";

import initialrequest from "./initialrequest";
import login from "./login";
import companyregister from "./companyregister";
import userregister from "./userregister";

// PublicAccountPages Root Saga
export default function* root(): Object {
  yield all([
    fork(initialrequest),
    fork(login),
    fork(companyregister),
    fork(userregister),
  ]);
}



// WEBPACK FOOTER //
// ./src/Sagas/PublicAccountPages/index.js